
import { useEffect } from 'react';
import { useParams } from 'react-router-dom';

import { useCentroCostoXID } from '../../../hooks';
import { DisenioPaginas } from '../../layout';
import { CargandoMedio, FormCreateUpdateProveedor } from '../../components';
import { FormCreateUpdateCentro } from '../../components/facturas';





export const CrearUpdateCentroCosto = () => {

    const { id } = useParams();
    const { data, isLoading } = useCentroCostoXID(id);
    

    const initialState = (data)
        ? { 
            nombre: data.nombre,
            fechaCreacion: data.fechaCreacion || '',
        }
        : { 
            nombre: '',
            fechaCreacion: '',
        }



    return (

        <DisenioPaginas titulo={`${(id != 'new') ? 'Actualizar' : 'Crear'} Centro Costo`} url={1} add={false} subtitulo="Información de centro costo">
            {(isLoading)
            ?   <CargandoMedio titulo="Cargando Centro Costo..." />
            :   <FormCreateUpdateCentro initialState={initialState} />
            }
        </DisenioPaginas>
    )   
}
